import { gql } from "@apollo/client";

export const UPSERT_DASHBOARD = gql`
  mutation UpsertDashboard($objectInput: UpsertDashboardInput!) {
    upsertDashboard(objectInput: $objectInput) {
      id
      name
      createdAt
      arenaId
      requiredRoles
      dashboardMetadata
    }
  }
`;
